/** @format */

import React, { useState } from 'react';
import Slider from 'react-slick';
import RotatingBanner from './rotating-banner';

export interface RotatingBannerContainerProps {
  paragraphData: ParagraphData;
}

export interface ParagraphData {
  paragraphStyle: string;
  bannerContainerHeight: string;
  rotationDuration: string;
  verticalMargins: string;
  banners: Banner[];
  paragraphId: string;
}

export interface Banner {
  title: string;
  subtitle: string;
  additionalText: string;
  textAlignment: string;
  backgroundColor: string;
  linkText: string;
  linkUrl: string;
  bannerImage: string;
}

/**
 * Rotating Banner.
 *
 * @param props
 */
const RotatingBannerContainer = (
  props: RotatingBannerContainerProps
): JSX.Element => {
  const { paragraphData } = props;
  const {
    bannerContainerHeight,
    rotationDuration,
    verticalMargins,
    banners,
    paragraphId,
  } = paragraphData;
  const [currentSlideIndex, setCurrentSlideIndex] = useState<number>(0);

  /**
   * Slider Settings.
   */
  const settings = {
    className: `simple-slider slide-count-${banners.length}`,
    dots: true,
    lazyLoad: true,
    infinite: true,
    fade: true,
    speed: 500,
    arrows: false,
    autoplay: true,
    autoplaySpeed: parseInt(rotationDuration, 10) * 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    afterChange: (current: number) => {
      setCurrentSlideIndex(current);
    },
  };
  const safeBackgroundColor =
    banners[currentSlideIndex]?.backgroundColor ?? 'white';
  /**
   * Render.
   */
  return (
    <div
      className={`${verticalMargins} background-${safeBackgroundColor} rotating-banner-container ${bannerContainerHeight}-height`}
      id={paragraphId}>
      <Slider {...settings}>
        {banners &&
          banners.length > 0 &&
          banners.map((banner, index: number) => {
            return <RotatingBanner banner={banner} key={index} />;
          })}
      </Slider>
    </div>
  );
};
export default RotatingBannerContainer;
